import { EMPTY, catchError, filter, skip, switchMap, tap, timeout } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { isVisible$ } from './rxjs.dom';

const clientVersion = import.meta.env.VITE_FULL_VERSION;

export const initializeVersionCheck = () =>
  isVisible$
    .pipe(
      filter(Boolean),
      skip(1), // Skip initial page load to avoid reload loop on feature branches
      switchMap(() =>
        fromFetch('/api/version', {
          selector: (res): Promise<{ version: string }> => res.json(),
        }).pipe(
          timeout(3_000),
          catchError(() => EMPTY)
        )
      ),
      tap(({ version }) => {
        if (version !== clientVersion) {
          window.location.reload();
        }
      })
    )
    .subscribe();
